import {CSSProperties, FC} from 'react';


export interface IIconHeightNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconHeightNissan: FC<IIconHeightNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m14.85 10.371-.963-2.467A1.42 1.42 0 0 0 12.551 7H7.419c-.6 0-1.137.364-1.338.907l-.936 2.47c-.228.09-.437.224-.616.4-.341.335-.529.775-.529 1.237v3.043c0 .64.548 1.16 1.221 1.16.622 0 1.136-.443 1.212-1.015h7.134c.075.572.59 1.015 1.212 1.015.639 0 1.221-.484 1.221-1.015v-3.217c0-.73-.477-1.356-1.15-1.614Zm-.071 1.76v1.332c0 .32-.274.58-.611.58H5.832c-.337 0-.61-.26-.61-.58v-1.449c0-.33.28-.608.61-.608h8.336c.337 0 .61.26.61.58v.144ZM7.233 8.29a.203.203 0 0 1 .186-.132h5.132c.08 0 .157.055.185.133l.762 1.954H6.492l.74-1.949.001-.005Zm-1.126 4.48a.824.824 0 1 1 1.649 0 .824.824 0 0 1-1.65 0Zm7.007-.824a.824.824 0 1 0 0 1.648.824.824 0 0 0 0-1.648Z" clipRule="evenodd" />
            <path d="M3 4H21V5H3z" />
            <path d="M3 19H21V20H3z" />
            <path d="M19 7h1v10h-1V7Z" />
            <path d="m19.5 6 1.299 1.5h-2.598L19.5 6ZM19.5 18l-1.299-1.5h2.598L19.5 18Z" />
        </svg>
    );
};
